import { useRef, useState } from "react";
import { Table, ConfigProvider } from "antd";
import { useBusCoursesQuery } from "src/services/react-query-apis/get-bus-courses";
import ActionButtonGroup from "src/components/common/Button/ActionButtonGroup";
import { toast } from "react-toastify";
import Select from "react-select";
import BusRouteEditForm from "./bus-route-edit-form";
import { useDeleteBusRouteMutation } from "src/services/react-query-apis/delete-bus-route";
import { swalConfirm } from "src/utils/swalHelpers";

const customTheme = {
  components: {
    Table: {
      rowHoverBg: "#D6EAF8",
    },
  },
};

const BusCourseDetails = () => {
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const formSubmitRef = useRef();

  const busCoursesQuery = useBusCoursesQuery({});

  const deleteBusRouteMutation = useDeleteBusRouteMutation({
    mutationConfig: {
      onSuccess: () => {
        toast.success("バス停が削除されました");
      },
    },
  });

  const handleDelete = () => {
    if (selectedCourseId) {
      swalConfirm("このバス停を削除してもよろしいですか？").then(willDelete => {
        if (willDelete) {
          deleteBusRouteMutation.mutate({
            courseId: selectedCourseId,
            routeId: selectedRouteId,
          });
        }
      });
    }
  };

  const selectedCourse = busCoursesQuery.data?.data.find(
    course => course.id === selectedCourseId
  );

  const selectedRoute = selectedCourse?.bus_routes.find(
    route => route.id === selectedRouteId
  );

  const rowClassName = record => {
    return record.id === selectedRouteId ? "selected-row" : "";
  };

  const data = selectedCourse?.bus_routes || [];

  const columns = [
    {
      title: "停留所名",
      dataIndex: "stop_name",
      key: "stop_name",
    },
    {
      title: "始点からの時間(分)",
      dataIndex: "time_from_start",
      key: "time_from_start",
    },
  ];

  const courseOptions = busCoursesQuery.data?.data.map(course => ({
    label: course.code,
    value: course.id,
  }));

  return (
    <div style={{ width: "65%" }}>
      <div className="card-body">
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              バスコース詳細
            </div>
            {selectedCourse && (
              <ActionButtonGroup
                storeHandler={() => {
                  formSubmitRef.current.click();
                }}
                deleteClasseHandler={handleDelete}
                updateClasseHandler={() => {
                  formSubmitRef.current.click();
                }}
                AddBtnEnbl={selectedRouteId === null}
                DltBtnEnbl={selectedRouteId !== null}
                UpdateBtnEnbl={selectedRouteId !== null}
              />
            )}
          </div>
          <div className="p-3">
            <div>
              <div style={{ width: "200px", zIndex: 2 }}>
                <Select
                  value={courseOptions?.find(
                    option => option.value === selectedCourseId
                  )}
                  onChange={newValue => {
                    setSelectedCourseId(newValue?.value);
                  }}
                  options={courseOptions}
                  placeholder="コースコード"
                  isClearable
                />
              </div>
            </div>
          </div>
        </div>
        {selectedCourse && (
          <BusRouteEditForm
            key={selectedRouteId}
            selectedCourse={selectedCourse}
            selectedRoute={selectedRoute}
            formSubmitRef={formSubmitRef}
            setSelectedRouteId={setSelectedRouteId}
          />
        )}
        <div style={{ marginTop: "10px" }}>
          <ConfigProvider theme={customTheme}>
            <Table
              bordered
              dataSource={data}
              columns={columns}
              loading={busCoursesQuery.isLoading}
              rowKey="id"
              pagination={false}
              rowClassName={rowClassName}
              onRow={record => ({
                onClick: () =>
                  setSelectedRouteId(r => (r === record.id ? null : record.id)),
              })}
              locale={{
                emptyText: busCoursesQuery.error
                  ? "データの取得に失敗しました"
                  : "データがありません",
              }}
            />
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

export default BusCourseDetails;
